import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/alloy-react-locale';
import SelectBox, { GroupedSelectBox } from '@adsk/alloy-select-box';
import FieldWrapper from '../FieldWrapper';

const DropdownField = ({
  clearable,
  onChange,
  options,
  placeholder,
  searchable,
  showSearchIcon,
  isEditing,
  required,
  title,
  tooltip,
  value,
  valueFormatter,
}) => {
  const { T } = useLocale(({ locale }) =>
    require(`../../../../i18n/${locale}.json`)
  );
  let content = T.translate('PROJECT_NOT_AVAILABLE');

  if (isEditing) {
    if (options && options[0]?.options) {
      content = (
        <GroupedSelectBox
          options={options}
          multiple={false}
          value={value && { value }}
          onChange={onChange}
          clearable={clearable}
          searchable={searchable}
          showSearchIcon={showSearchIcon}
        >
          {(props) => <SelectBox {...props} />}
        </GroupedSelectBox>
      );
    } else {
      content = (
        <SelectBox
          options={options}
          value={value && { value }}
          onChange={onChange}
          placeholder={placeholder}
          clearable={clearable}
          searchable={searchable}
          showSearchIcon={showSearchIcon}
        />
      );
    }
  } else if (value) {
    content = valueFormatter(value);
  }

  return (
    <FieldWrapper
      title={title}
      tooltip={tooltip}
      isEditing={isEditing}
      required={required}
    >
      {content}
    </FieldWrapper>
  );
};

DropdownField.propTypes = {
  clearable: PropTypes.bool,
  isEditing: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  searchable: PropTypes.bool,
  showSearchIcon: PropTypes.bool,
  title: PropTypes.string,
  tooltip: PropTypes.element,
  value: PropTypes.string,
  valueFormatter: PropTypes.func,
};

DropdownField.defaultProps = {
  valueFormatter: (value) => value,
};

export default DropdownField;
